<template>
  <Transition name="modal">
    <div v-if="props.optionsSubsExit.showModal" class="modal-mask" id="modalSubscribeExit">
      <div class="modal-container">
          <div class="modal-header">
          <button class="close-black" @click="emit('showModalSubscribeExit', {message: {show: false}})">
              <img src="https://api.belladasemana.com.br/storage/2015/ico_x_black-t.png" alt="Close" class="close-modal">
          </button>
          </div>
          <div class="modal-body" v-html="props.optionsSubsExit.html"></div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
const  props = defineProps({
    optionsSubsExit: {
        type: Object,
        required: true
    }
})
const emit = defineEmits(['showModalSubscribeExit'])

</script>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    transition: opacity 0.3s ease;
}

.modal-container {
    width: 600px;
    margin: auto;
    padding: 0px 0px;
    background-color: #fff;
    border-radius: 0px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
}

.modal-header {
    display: block;
    text-align: center;
}

.modal-body {
    margin: 0;
    padding: 0px 0px;
}

.modal-footer {
    justify-content: center;
}

.modal-default-button {
    float: right;
}

/*
* The following styles are auto-applied to elements with
* transition="modal" when their visibility is toggled
* by Vue.js.
*
* You can easily play with the modal transition by editing
* these styles.
*/

.modal-enter-from {
    opacity: 0;
}

.modal-leave-to {
    opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}

.close-black {
    position: absolute;
    right: 0px;
    top: 0px;
    z-index: 1;
}

:deep(.modal-body img) {
    width: 100%;
}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {
    .modal-container {
    width: 95%;
    }
    .close-modal {
        width: 30px;
        height: 30px;
    }   
}
</style>